import { useCallback, useEffect, useState } from "react";
import { getWidgetPrefs, updateWidgetPrefs } from "./api";

// Defaults are used both as the initial state and as the fallback if the
// fetch fails, so there's no layout flash: a first-time (or offline) user
// sees exactly today's fixed layout, which is what the defaults represent.
export function useWidgetPrefs(defaultWidgetIds: string[]) {
  const [widgetIds, setWidgetIds] = useState<string[]>(defaultWidgetIds);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;

    void getWidgetPrefs()
      .then((response) => {
        if (!cancelled) setWidgetIds(response.widget_ids);
      })
      .catch(() => {
        // Fail open to the defaults already set as initial state.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const save = useCallback(async (nextWidgetIds: string[]) => {
    setSaving(true);
    try {
      const response = await updateWidgetPrefs(nextWidgetIds);
      setWidgetIds(response.widget_ids);
      return response.widget_ids;
    } finally {
      setSaving(false);
    }
  }, []);

  const resetToDefault = useCallback(() => save(defaultWidgetIds), [save, defaultWidgetIds]);

  return { widgetIds, saving, save, resetToDefault };
}
